import { render, staticRenderFns } from "./Dian.vue?vue&type=template&id=2e38baec&scoped=true&"
import script from "./Dian.vue?vue&type=script&lang=js&"
export * from "./Dian.vue?vue&type=script&lang=js&"
import style0 from "./Dian.vue?vue&type=style&index=0&id=2e38baec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e38baec",
  null
  
)

export default component.exports